import { useState } from "react";
import { DataGrid, GridCellParams, GridSortModel } from "@mui/x-data-grid";

// Registros por página que se muestran por defecto en todas las tablas
export const DEFAULT_PAGE_SIZE = 50;
const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

// Paginación y orden en el servidor: la tabla solo pinta la página recibida
export type ServerPagination = {
  rowCount: number;
  page: number; // empieza en 0, como la tabla
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  sortModel: GridSortModel;
  onSortModelChange: (model: GridSortModel) => void;
  loading?: boolean;
};

type ListEditItemsProps = {
  rows: any[];
  columns: any[];
  // Al hacer clic en una fila (salvo en la columna de acciones) se abre su ficha
  onRowClick?: (row: any) => void;
  // Ocupa todo el alto disponible y hace scroll dentro, en lugar de crecer con las filas
  fillHeight?: boolean;
  server?: ServerPagination;
};

export const ListEditItems = ({ rows, columns, onRowClick, fillHeight = false, server }: ListEditItemsProps) => {
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const handleCellClick = (params: GridCellParams) => {
    if (onRowClick && params.field !== "actions") onRowClick(params.row);
  };

  const paginationProps = server
    ? {
        paginationMode: "server" as const,
        sortingMode: "server" as const,
        rowCount: server.rowCount,
        page: server.page,
        onPageChange: server.onPageChange,
        pageSize: server.pageSize,
        onPageSizeChange: server.onPageSizeChange,
        sortModel: server.sortModel,
        onSortModelChange: server.onSortModelChange,
        loading: server.loading,
      }
    : { pageSize, onPageSizeChange: setPageSize };

  return (
    <div className={fillHeight ? "tableContainer tableContainer--fill" : "tableContainer"}>
      <DataGrid
        className={onRowClick ? "clickableRows" : undefined}
        rows={rows}
        columns={columns}
        {...paginationProps}
        rowsPerPageOptions={PAGE_SIZE_OPTIONS}
        pagination
        autoHeight={!fillHeight}
        onCellClick={handleCellClick}
      />
    </div>
  )
}
